import { put, call, takeLatest, all, select } from "redux-saga/effects";
import { getWorkkardOwnerListV2 } from "../../../SpockViewPage/api";
import { fetchRelationships } from "../../../AdminPanel/api";
import { getOrgId } from "../../../../utils/authManager";
import {
  fetchTeamMembersRequest,
  fetchB2bListRequest,
  fetchContractListRequest,
  fetchAssignmentListSuccess,
  fetchAssignmentListError,
} from "./assignmentMethodSlice";

function normalizeTeamMembers(response) {
  const usersList = response?.users || response?.data?.users || [];
  return usersList.map((user) => ({
    UserId: user.id,
    FirstName: user.first_name || user.user_name || "",
    LastName: user.last_name || "",
    Title: user.user_role || "",
    Email: user.email || "",
    ProfileImage: user.profile_image || "",
  }));
}

function normalizeB2BList(response, currentOrgId) {
  const items = Array.isArray(response?.business_orgs)
    ? response.business_orgs
    : [];
  return items
    .map((item) => {
      const otherOrg =
        item.assignee === currentOrgId
          ? item.source_org || {}
          : item.destination_org || {};
      return {
        OrganizationId: otherOrg.id,
        OrganizationName: otherOrg.name || "",
        OrganizationImage: otherOrg.profile_image || "",
      };
    })
    .filter((org) => org.OrganizationId);
}

function* fetchTeamMembersSaga() {
  try {
    const response = yield call(getWorkkardOwnerListV2);
    yield put(fetchAssignmentListSuccess(normalizeTeamMembers(response)));
  } catch (error) {
    yield put(
      fetchAssignmentListError(
        error?.message || "Failed to fetch team members",
      ),
    );
  }
}

function* fetchB2bListSaga() {
  try {
    const currentOrgId = Number(getOrgId());
    const response = yield call(fetchRelationships, { status: "ACCEPTED" });
    yield put(
      fetchAssignmentListSuccess(normalizeB2BList(response, currentOrgId)),
    );
  } catch (error) {
    yield put(
      fetchAssignmentListError(error?.message || "Failed to fetch B2B list"),
    );
  }
}

function* fetchContractListSaga() {
  yield put(fetchAssignmentListSuccess([]));
}

export default function* assignmentMethodSaga() {
  yield all([
    takeLatest(fetchTeamMembersRequest.type, fetchTeamMembersSaga),
    takeLatest(fetchB2bListRequest.type, fetchB2bListSaga),
    takeLatest(fetchContractListRequest.type, fetchContractListSaga),
  ]);
}